const formatPower = (p) => (/^\d+(\.\d+)?$/.test(p) ? `${p}W` : p);

const formatArea = (a) => {
  if (!a) return '';
  const s = a.replace(/\s*[x×]\s*/gi, ' x ').replace(/\s*mm\s*$/i, '').trim();
  return s ? `${s} mm` : '';
};

const areaSize = (a) => {
  const n = (a.match(/\d+(\.\d+)?/g) || []).map(Number);
  return n.length >= 2 ? n[0] * n[1] : 0;
};

export const parseModels = (raw) =>
  (raw || '')
    .split('\n')
    .map((l) => l.split('|').map((s) => s.trim()))
    .filter((p) => p[0])
    .map((p) => ({
      name: p[0],
      power: formatPower(p.length > 3 ? p.slice(1, -1).filter(Boolean).join(' + ') : p[1] || ''),
      area: p.length > 2 ? formatArea(p[p.length - 1]) : '',
    }));

const unique = (arr) => [...new Set(arr.filter(Boolean))];

export const powerRange = (models, fallback, sep = ' à ') => {
  const powers = unique(models.map((m) => m.power));
  if (!powers.length) return fallback;
  const nums = powers.map((p) => (/^\d+(\.\d+)?\s*W$/i.test(p) ? parseFloat(p) : null));
  if (nums.every((n) => n !== null)) {
    const min = Math.min(...nums);
    const max = Math.max(...nums);
    return min === max ? `${min}W` : `${min}W${sep}${max}W`;
  }
  return powers.join(' / ');
};

export const areaRange = (models, fallback, sep = ' à ') => {
  const areas = unique(models.map((m) => m.area)).sort((a, b) => areaSize(a) - areaSize(b));
  if (!areas.length) return fallback;
  if (areas.length === 1) return areas[0];
  return `${areas[0].replace(/ mm$/, '')}${sep}${areas[areas.length - 1]}`;
};
